export default {"src":"/_next/static/media/play.b96adec8.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};